import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../Styles/Common.module.css';
import Button from '../Styles/Button.module.css';
import BreadcrumbComponent from "../Common/CommonSections/Breadcrum";
import { BiPhoneCall } from "react-icons/bi";
import { GoMail } from "react-icons/go";
import { Link } from "react-router-dom";

const SecurityInformationPage = ()=>{
    return(
        <div>
            <BreadcrumbComponent home='Home' listOne="Security Information" />
            <div className={Style.pageTitle + ' ' + Style.marginUp90}>
                <Container>
                    <Row>
                        <Col>
                            <div className={Style.sectionTitle}>
                                <h2>Security Information</h2>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={Style.aboutmayocollege + ' ' + Style.pageBoder}>
                                <p>Thank you for entrusting Mayo College Alumni Association Delhi with your information. We prioritize the security and confidentiality of your data. Here's important security information regarding our practices:</p>
                                <h3>Data Encryption:</h3>
                                <p>All data transmitted between your device and our servers is encrypted using industry-standard protocols to safeguard it from unauthorized access.</p>
                                <h3>Secure Servers:</h3>
                                <p>Our servers are hosted in secure data centers with robust physical and digital security measures to protect against data breaches and unauthorized access.</p>
                                <h3>Access Controls:</h3>
                                <p>Access to member information and sensitive data is restricted to authorized personnel only. We implement strict access controls to ensure data integrity.</p>
                                <h3>Regular Security Audits:</h3>
                                <p>We conduct regular security audits and assessments to identify and address potential vulnerabilities in our systems and processes.</p>
                                <h3>Compliance with Data Protection Laws:</h3>
                                <p>Mayo College Alumni Association Delhi adheres to applicable data protection laws, including GDPR/other relevant regulations, to ensure the lawful and ethical processing of personal information.</p>
                                <h3>Member Authentication:</h3>
                                <p>We employ secure authentication methods to verify the identity of members accessing our platform, adding an extra layer of protection.</p>
                                <h3>Incident Response Plan:</h3>
                                <p>In the event of a security incident, we have a comprehensive incident response plan in place to promptly address and mitigate any potential risks.</p>
                                <h3>Regular Software Updates:</h3>
                                <p>Our systems and software are regularly updated to incorporate the latest security patches and features, reducing the risk of vulnerabilities.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default SecurityInformationPage;